module.exports = __webpack_public_path__ + "static/media/state2026.39183c58.jpg";